var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "#BDBDBD",
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeWidth: 0.4,
    d: "M7 13v-2h2v2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.679 10.448H7.224a44.94 44.94 0 0 1-.005-.453c0-.558.078-1.017.233-1.377.156-.36.468-.765.936-1.216.468-.45.747-.745.838-.884.14-.22.211-.464.211-.73 0-.368-.124-.685-.373-.948-.25-.263-.585-.395-1.007-.395-.407 0-.747.137-1.02.412-.275.274-.463.693-.566 1.256L5 5.897c.042-.806.332-1.49.87-2.053S7.114 3 7.989 3c.92 0 1.652.285 2.195.854.544.57.816 1.232.816 1.989 0 .418-.1.814-.3 1.188-.2.374-.626.882-1.28 1.526-.338.333-.548.601-.63.804-.082.202-.119.564-.111 1.087z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.273841d4895e38463df79c75cd89902b.svg";
export { ForwardRef as ReactComponent };